import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, IconButton, Typography, Fade } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VolumeOffIcon from "@material-ui/icons/VolumeOff";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";

const VIDEO_SRC = "/lifecoach/lifecoach-quick-version-optimized30fps.mp4";
const POSTER_SRC = "/lifecoach/banner.png";

const useStyles = makeStyles((theme) => ({
  section: {
    maxWidth: 1120,
    margin: "0 auto",
    padding: theme.spacing(6, 3, 10, 3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4, 2, 6, 2),
    },
  },
  frame: {
    position: "relative",
    width: "100%",
    aspectRatio: "16 / 9",
    borderRadius: 20,
    overflow: "hidden",
    background: "#000",
    boxShadow:
      "0 30px 80px -20px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.06) inset",
  },
  video: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  muteBtn: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
    background: "rgba(0,0,0,0.55)",
    backdropFilter: "blur(6px)",
    color: "#fafafa",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.75)",
    },
  },
  hint: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(8),
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 999,
    background: "rgba(0,0,0,0.55)",
    backdropFilter: "blur(6px)",
    fontFamily: "Roboto Mono, monospace",
    fontSize: "0.72rem",
    color: "rgba(255,255,255,0.9)",
    letterSpacing: "0.04em",
    pointerEvents: "none",
  },
}));

export const VideoBlock = () => {
  const classes = useStyles();
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [hintVisible, setHintVisible] = useState(true);
  const [interacted, setInteracted] = useState(false);

  const toggleMute = useCallback(() => {
    if (!videoRef.current) return;
    const next = !videoRef.current.muted;
    videoRef.current.muted = next;
    setMuted(next);
    setInteracted(true);
    setHintVisible(false);
    if (!next && videoRef.current.paused) {
      videoRef.current.play().catch(() => {});
    }
  }, []);

  useEffect(() => {
    if (interacted) return;
    const timer = setTimeout(() => setHintVisible(false), 6000);
    return () => clearTimeout(timer);
  }, [interacted]);

  return (
    <Box className={classes.section}>
      <Box className={classes.frame}>
        <video
          ref={videoRef}
          className={classes.video}
          src={VIDEO_SRC}
          poster={POSTER_SRC}
          autoPlay
          muted
          loop
          playsInline
          controls
          preload="metadata"
        />
        <Fade in={hintVisible && muted} timeout={600}>
          <Typography className={classes.hint}>Tap for sound</Typography>
        </Fade>
        <IconButton
          className={classes.muteBtn}
          onClick={toggleMute}
          aria-label={muted ? "Unmute video" : "Mute video"}
          size="small"
        >
          {muted ? <VolumeOffIcon fontSize="small" /> : <VolumeUpIcon fontSize="small" />}
        </IconButton>
      </Box>
    </Box>
  );
};
